
<div class="mr-2 mr-2 measures">
    <div class="measure-title secondary white--text mb-1">
        {{ title }}
    </div>
    <div class="measure-group" >
        <p-lgs-measure-card
            class    = "w-100 mb-5"
            v-for    = "(measure, index) in measures"
            :key     = "index"
            :id      = "measure.id"
            :name    = "$t(measure.name)"
            :measure = "measure.measure"
            :hint    = "measure.hint ? $t(measure.hint) : null"
            @click   = "onClick"
        />
    </div>
</div>
